import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "@babackapp/ui/components/dialog";
import useTranslation from "@babackapp/translations/use-translation";
import { useCallback } from "react";
import { useCarriersContext } from "../../use-carriers-context";
import {
  CarrierDto,
  UpdateCarrierDto,
} from "@babackapp/private-api-client/types";
import { CarrierTransportForm } from "./carrier-transport-form";
import { FedexPlanSelect } from "./fedex-plan-select";

export const EditCarrierTransportDialog = ({
  isOpen,
  setIsModalOpen,
  selectedCarrier,
  onClose,
}: {
  isOpen: boolean;
  setIsModalOpen: (open: boolean) => void;
  selectedCarrier: CarrierDto;
  onClose: () => void;
}) => {
  const t = useTranslation();
  const { editOneCarrierTransport } = useCarriersContext();
  const { addOneUpsCarrierTransport } = useCarriersContext();
  const onSubmitEditCarrierTransport = useCallback((data: UpdateCarrierDto) => {
    editOneCarrierTransport({ carrier: data, carrierId: selectedCarrier.id });
    onClose();
  }, []);

  const onSubmitUps = useCallback(
    (data: { accountNumber: string; carrierType: string }) => {
      addOneUpsCarrierTransport({
        accountNumber: data.accountNumber,
        carrierType: data.carrierType,
        carrierId: selectedCarrier.id,
      });
    },
    [],
  );
  return (
    <Dialog open={isOpen} onOpenChange={setIsModalOpen}>
      <DialogContent className="pt-10">
        <DialogHeader>
          <DialogTitle> {t("carrier.label")}</DialogTitle>
          <DialogDescription>{t("carrier.subLabel")}</DialogDescription>
        </DialogHeader>
        <CarrierTransportForm
          defaultValues={{
            code: selectedCarrier.code,
            credentials: {
              accountId: selectedCarrier.preferences.accountId || undefined,
              webSiteId: selectedCarrier.preferences?.webSiteId || undefined,
              accountNumber:
                selectedCarrier.preferences?.accountNumber || undefined,
              subAccount: selectedCarrier.preferences?.subAccount || undefined,
              SLS: selectedCarrier.preferences?.SLS || undefined,
              customerCountryCode:
                selectedCarrier.preferences?.customerCountryCode || undefined,
              customerCenterNumber:
                selectedCarrier.preferences?.customerCenterNumber || undefined,
              customerNumber:
                selectedCarrier.preferences?.customerNumber || undefined,
              userid: selectedCarrier.preferences?.userid || undefined,
              shipperAccountNumber:
                selectedCarrier.preferences?.shipperAccountNumber || undefined,
              brand: selectedCarrier.preferences?.brand || undefined,
              login: selectedCarrier.preferences?.login || undefined,
              password: selectedCarrier.preferences?.password || undefined,
              securityKey:
                selectedCarrier.preferences?.securityKey || undefined,
              livRel: selectedCarrier.preferences?.livRel || undefined,
            },
          }}
          onSubmit={onSubmitEditCarrierTransport}
          onSubmitUps={onSubmitUps}
        />
        {selectedCarrier.code === "fedex" && (
          <FedexPlanSelect
            carrierId={selectedCarrier.id}
            currentPlan={selectedCarrier.preferences?.fedexPlan}
          />
        )}
      </DialogContent>
    </Dialog>
  );
};
